import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import CInput from "uis/CInput";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";

import CTable, {
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";
import ErrorMessage from "components/ErrorMessage";

const styles = theme => {
  return {
    dialogTitle: {
      width: 700,
      display: "flex"
    },
    title: {
      flex: 1,
      margin: 0
    },
    errorMessage: {
      fontSize: ".9rem",
      margin: "10px 30px 0"
    },
    editActions: {
      textAlign: "right"
    },
    deleteBtn: {
      margin: "10px 0 10px 30px",
      backgroundColor: theme.palette.remove.dark,
      "&:hover": {
        backgroundColor: theme.palette.remove.light
      }
    },
    dialogContent: {
      paddingTop: 0
    },
    hide: {
      display: "none"
    },
    table: {
      marginBottom: 40
    },
    headCell: {
      width: 180
    },
    customerKeyInput: {
      width: 310
    },
    caution: {
      textAlign: "center",
      color: theme.palette.error.main,
      fontSize: ".9rem"
    }
  };
};

const CustomerAdminModal = props => {
  const {
    classes,
    title,
    customerAdmin,
    open,
    errors,
    action,
    btnLabel
  } = props;

  return (
    <Dialog open={open}>
      <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>

      <ErrorMessage messages={errors} className={classes.errorMessage} />

      <DialogContent className={action === "edit" ? classes.dialogContent : ""}>
        <div className={action === "edit" ? classes.editActions : classes.hide}>
          <Button
            raised
            dense
            onClick={() => props.handlePasswordReset(customerAdmin)}
          >
            パスワードリセット
          </Button>
          <Button
            raised
            dense
            className={classes.deleteBtn}
            onClick={() => props.handleDelete(customerAdmin)}
          >
            削除
          </Button>
        </div>

        <CTable className={classes.table}>
          <CTableBody>
            <CTableRow>
              <CHeadCell className={classes.headCell}>担当者ID *</CHeadCell>
              <CBodyCell>
                <CInput
                  id="admin-key"
                  value={customerAdmin.adminKey}
                  onChange={e => props.changeForm("adminKey", e.target.value)}
                  className={classes.customerKeyInput}
                  inputProps={{
                    maxLength: 20
                  }}
                />
              </CBodyCell>
            </CTableRow>

            <CTableRow>
              <CHeadCell>担当者名 *</CHeadCell>
              <CBodyCell>
                <CInput
                  id="admin-key"
                  value={customerAdmin.adminName}
                  onChange={e => props.changeForm("adminName", e.target.value)}
                />
              </CBodyCell>
            </CTableRow>

            <CTableRow>
              <CHeadCell>メールアドレス *</CHeadCell>
              <CBodyCell>
                <CInput
                  id="mail"
                  value={customerAdmin.mail}
                  onChange={e => props.changeForm("mail", e.target.value)}
                  fullWidth
                />
              </CBodyCell>
            </CTableRow>

            <CTableRow>
              <CHeadCell>メモ</CHeadCell>
              <CBodyCell>
                <CInput
                  id="memo"
                  value={customerAdmin.memo || ""}
                  onChange={e => props.changeForm("memo", e.target.value)}
                  fullWidth
                  multiline
                />
              </CBodyCell>
            </CTableRow>
          </CTableBody>
        </CTable>

        <div
          className={`${action === "edit" ? classes.hide : ""} ${
            classes.caution
          }`}
        >
          ※ 初期パスワードが記載されたメールが担当者宛てに送信されます
        </div>
      </DialogContent>

      <DialogActions>
        <Button raised onClick={props.handleClose}>
          キャンセル
        </Button>
        <Button
          raised
          onClick={() => {
            return action === "new"
              ? props.handleCreate(customerAdmin)
              : props.handleUpdate(customerAdmin);
          }}
        >
          {btnLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(CustomerAdminModal);



// WEBPACK FOOTER //
// ./src/components/CustomerDetail/CustomerAdminModal.jsx